import {
    Paper,
    Table,
    Button,
    TextField,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Switch,
    FormGroup,
    Typography,
    TableRow,
    TableHead,
    TableCell,
    Dialog,
  } from "@material-ui/core";
  import Stack from '@mui/material/Stack';
  import GetRole from "./user";
  import { makeStyles } from "@material-ui/core/styles";
  import { rzbookingdetails, rzcpafterbooking, rzcondetails, rzhotelcancel, updateRezdata, fetchrezconfbooking, fetchrezallbooking} from "../api/customerapi";
  import { useEffect } from "react";
  import useState from 'react-usestateref'
  import { XMLParser } from "fast-xml-parser";

  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    formgroup: {
      justifyContent: "center",
    },
    texttypo2: {
      marginTop: 0,
      color: "#a8020b",
      verticalAlign: "middle",
      //font:"Helvetica",
    },
  
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(14),
      height: theme.spacing(3),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
      fontSize: 10,
      verticalAlign: "middle",
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(10),
      height: theme.spacing(3),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      fontSize: 10,
      verticalAlign: "middle",
    },
    textField: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
  }));

  

 

const RezliveView = () => {
    const classes = useStyles();
    const [bookings, setbookings] = useState([]);
    const [bookings2, setbookings2] = useState([]);
    const [statusdata, setstatusdata] = useState([]);
    const [detailsdata, setdetailsdata] = useState([]);
    const [cpdata, setcpdata] = useState([]);
    const [canceldata, setcanceldata] = useState([]);
    const [dialog1, setdialog1] = useState(false);
    const [dialog2, setdialog2] = useState(false);
    const [dialog3, setdialog3] = useState(false);
    const [dialog4, setdialog4] = useState(false);
    const [bookingdetails2, setbookingdetails2] = useState(false);
    const [searchData, setsearchData] = useState({});

    useEffect(() => {
      getBookings();
    }, []);

    useEffect(() => {
      
      if(bookingdetails2){
        //console.log("ABC")
        getallBookings()
      }else{
        getBookings()
      }
      
    }, [bookingdetails2]);

    const getBookings=async()=>{
      const data=await fetchrezconfbooking()
      //console.log(data.data)
      setbookings(data.data)
      setbookings2(data.data)
    }

    const getallBookings=async()=>{
      //console.log("ABC")
      const data=await fetchrezallbooking()
      setbookings(data.data)
      setbookings2(data.data)
    }

    const bookingconfirm=async(booking)=>{
      //console.log(booking)
      const bid=booking.bookingid
      const bcode=booking.bookingcode
  
      var data = {
        'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelConfirmationRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Confirmation>\n      <BookingId>'+bid+'</BookingId>\n      <BookingCode>'+bcode+'</BookingCode>\n    </Confirmation>\n</HotelConfirmationRequest>'
      };
      //console.log(data)
  
      const resdata = await rzcondetails(data)
      //console.log(resdata.data)
      const parser = new XMLParser();
      const jObj = parser.parse(resdata.data);
      //console.log(jObj.HotelConfirmationResponse)
      setstatusdata(jObj.HotelConfirmationResponse)
      setdialog1(true)
    }
  
    const cancelbooking=async(booking)=>{
      let a=window.confirm("Are you sure you want to cancel?");
      if(a){
        const bid=booking.bookingid
        const bcode=booking.bookingcode
    
        var data = {
          'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<CancellationRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Cancellation>\n      <BookingId>'+bid+'</BookingId>\n      <BookingCode>'+bcode+'</BookingCode>\n    </Cancellation>\n</CancellationRequest>'
        };
        console.log(data)
    
        const resdata = await rzhotelcancel(data)
        console.log(resdata.data)
        const parser = new XMLParser();
        const jObj = parser.parse(resdata.data);
        console.log(jObj.CancellationResponse)
        setcanceldata(jObj.CancellationResponse)
        setdialog4(true)
        const data2=await updateRezdata({code:booking.bookingcode})
      }
     
    }
  
    const bookingdetails=async(booking)=>{
  
      const bid=booking.bookingid
      const bcode=booking.bookingcode
  
      var data = {
        'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<GetBookingRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n        <BookingId>'+bid+'</BookingId>\n      <BookingCode>'+bcode+'</BookingCode>\n   </GetBookingRequest>'
      };
      //console.log(data)
  
      const resdata = await rzbookingdetails(data)
      console.log(resdata.data)
      const parser = new XMLParser();
      const jObj = parser.parse(resdata.data);
      //console.log(jObj)
      setdetailsdata(jObj.GetBookingResponse)
      setdialog2(true)
    }
  
    const getcpafterbooking=async(booking)=>{
  
      const bid=booking.bookingid
      const bcode=booking.bookingcode
  
      var data = {
        'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<CancellationPolicyAfterBookingRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n      <BookingId>'+bid+'</BookingId>\n      <BookingCode>'+bcode+'</BookingCode>\n  </CancellationPolicyAfterBookingRequest>'
      };
      //console.log(data)
  
      const resdata = await rzcpafterbooking(data)
      //console.log(resdata.data)
      const parser = new XMLParser();
      const jObj = parser.parse(resdata.data);
      //console.log(jObj.GetCancellationPolicyAfterBookingResponse)
      setcpdata(jObj.GetCancellationPolicyAfterBookingResponse)
      setdialog3(true)
    }

    const handleClose1 = () => {
      setdialog1(false);
      //window.open("/hotelview")
    };

    const handleClose2 = () => {
      setdialog2(false);
      //window.open("/hotelview")
    };

    const handleClose3 = () => {
      setdialog3(false);
      //window.open("/hotelview")
    };

    const handleClose4 = () => {
      setdialog4(false);
      window.location.reload(false)
    };

    const handleChange = () => {
      setbookingdetails2(!bookingdetails2)
    }

    const filterbooking=() => {
      const capture=bookings2
      if(searchData.bookingstatus){
        var temp=capture.filter(b=>b.bookingstatus==searchData.bookingstatus)
        setbookings(temp)
      }else{
        setbookings(capture)
      }
    }
    
    return (
      <div>
      <Switch  onChange={handleChange} color="secondary" label="Search All/Confirmed"/>
      <Dialog fullWidth maxWidth="m" open={dialog1} onClose={handleClose1}>
      {statusdata && "ConfirmationDetails" in statusdata?(
        <div>
        <Typography className={classes.texttypo2} variant="h6">Booking Status: {statusdata.ConfirmationDetails.ConfirmationStatus}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Confirmation No.: {statusdata.ConfirmationDetails.HotelConfirmationNo}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Hotel Staff: {statusdata.ConfirmationDetails.HotelStaffName}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Hotel Contact: {statusdata.ConfirmationDetails.HotelTelephoneNo}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Confirmation Note: {statusdata.ConfirmationDetails.ConfirmationNote}</Typography>
        </div>
      ):(
        <Typography variant="h6">Unable to fetch data</Typography>
      )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog2} onClose={handleClose2}>
        {detailsdata && "Booking" in detailsdata?(
          <div>
        <Typography className={classes.texttypo2} variant="h6">Booking Status: {detailsdata.BookingStatus}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Check-In.: {detailsdata.CheckIn}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Check-Out: {detailsdata.CheckOut}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Hotel Info: {detailsdata.Booking.HotelInfo.HotelName} ({detailsdata.Booking.HotelInfo.HotelCity})</Typography>
          <Typography className={classes.texttypo2} variant="h6">Main Passenger: {detailsdata.Booking.HotelInfo.LeaderFirstName} {detailsdata.Booking.HotelInfo.LeaderLastName}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Price: {detailsdata.Booking.RateInfo.CurrencyCode} {detailsdata.Booking.RateInfo.TotalRate}</Typography>
          <Typography className={classes.texttypo2} variant="h6">Room: {detailsdata.Booking.RoomInfo.RoomType} </Typography>
          <Typography className={classes.texttypo2} variant="h6">Pax: {detailsdata.Booking.RoomInfo.NoOfAdult} Adults + {detailsdata.Booking.RoomInfo.NoOfChild} Child</Typography>
          <Typography className={classes.texttypo2} variant="h6">Guests: </Typography>
          {"GuestInfos" in detailsdata.Booking.RoomInfo && "GuestInfo" in detailsdata.Booking.RoomInfo.GuestInfos?(<div>
            { Array.isArray(detailsdata.Booking.RoomInfo.GuestInfos.GuestInfo)?(
            <div>
            {detailsdata.Booking.RoomInfo.GuestInfos.GuestInfo.map(guest=>
              <div>
              <Typography variant="h6">{guest.PaxType} {guest.Salutation} {guest.FirstName} {guest.LastName}</Typography>
              </div>
            )}
            </div>
          ):(
            <Typography variant="h6">{detailsdata.Booking.RoomInfo.GuestInfos.GuestInfo.PaxType} {detailsdata.Booking.RoomInfo.GuestInfos.GuestInfo.Salutation} {detailsdata.Booking.RoomInfo.GuestInfos.GuestInfo.FirstName} {detailsdata.Booking.RoomInfo.GuestInfos.GuestInfo.LastName}</Typography>
          )}
          </div>):("")}
        </div>
        ):(
          <Typography variant="h6">Unable to fetch data</Typography>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog3} onClose={handleClose3}>
        {cpdata && "CancellationPolicyResponse" in cpdata?(
          <div>
          {"CancellationInformations" in cpdata.CancellationPolicyResponse && "CancellationInformation" in cpdata.CancellationPolicyResponse.CancellationInformations?(<div>
            { Array.isArray(cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation)?(
            <div>
            {cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation.map(ci=>
              <div>
              <h3 className={classes.headertext}>From {ci.StartDate} to {ci.EndDate} - {ci.ChargeAmount} {ci.ChargeType} {ci.Currency}</h3>
              </div>
            )}
            </div>
          ):(
            <h3 className={classes.headertext}>From {cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation.StartDate} to {cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation.EndDate} -  {cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation.ChargeAmount} {cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation.ChargeType} {cpdata.CancellationPolicyResponse.CancellationInformations.CancellationInformation.Currency}</h3>
          )}
          </div>):("")}
        </div>
        ):(
          <Typography variant="h6">Unable to fetch data</Typography>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog4} onClose={handleClose4}>
        {canceldata?(
          <div>
          <Typography variant="h6">Booking Code: {canceldata.BookingCode}</Typography>
          {"Error" in canceldata?(
            <Typography variant="h6">Error: {canceldata.Error}</Typography>
          ):(
            <Typography variant="h6">Cancellation Charges: {canceldata.Currency} {canceldata.CancellationCharges}</Typography>
          )}
          </div>
        ):(
          <Typography variant="h6">Unable to fetch data</Typography>
        )}
      </Dialog>
        <Paper id="myDIV" variant="outlined" className={classes.paper}>
        <div align="center">
            <Typography>Booked Hotel List</Typography>
            {bookingdetails2?(
              <div>
              <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="status">Booking Status</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="status"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={searchData.bookingstatus}
                onChange={(e) => setsearchData({...searchData, bookingstatus:e.target.value})}
              >
              <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Confirmed"}>Confirmed</MenuItem>
                <MenuItem value={"Fail"}>Fail </MenuItem>
                <MenuItem value={"Rejected"}>Rejected</MenuItem>
                <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
              </Select>
            </FormControl>
            <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>filterbooking()}
                    
                    className={classes.button}
                  >
                    Filter
            </Button>
              </div>
            ):("")}
            <Table>
            <TableHead>
                <TableCell>
                  Booking Code
                </TableCell>
                <TableCell>
                  City
                </TableCell>
                <TableCell>
                  Hotel
                </TableCell>
                <TableCell>
                  Date of Travel
                </TableCell>
                <TableCell>
                  Price
                </TableCell>
                <TableCell>
                  Status
                </TableCell>
                <TableCell>
                  Action Buttons
                </TableCell>
              </TableHead>
            {bookings.map(booking=>
             
              <TableRow>
                <TableCell>
                  {booking.bookingcode}
                </TableCell>
                <TableCell>
                  {booking.city}
                </TableCell>
                <TableCell>
                  {booking.hotelname}
                </TableCell>
                <TableCell>
                  {booking.startdate?booking.startdate.split("T").slice(0,1):""}
                </TableCell>
                <TableCell>
                  {booking.bookingprice}
                </TableCell>
                <TableCell>
                  {booking.bookingstatus}
                </TableCell>
                <TableCell>
                <FormGroup row className={classes.formgroup}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>bookingconfirm(booking)}
                    
                    className={classes.button}
                  >
                    Status
            </Button>
            <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>getcpafterbooking(booking)}
                    
                    className={classes.button}
                  >
                    Get CP
            </Button>
            <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>bookingdetails(booking)}
                    
                    className={classes.button}
                  >
                    Details
            </Button>
            <Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>cancelbooking(booking)}
                    
                    className={classes.button}
                  >
                    Cancel
            </Button>
                </FormGroup>
                
            </TableCell>
            
              </TableRow>
              
            )}
            </Table>
            
        </div>
        </Paper>
        </div>
)}

export default RezliveView;